import { msg } from "@lingui/core/macro";

export const startDateAfterDateRuleMessages = {
	name: msg({ message: "Start Date after Date" }),
	description: msg({ message: "Permit Start Date must be on or after a Date" }),
	errors: {
		isBefore: msg({ message: "Permit must start on or after {date}" }),
	},
} as const;
